module.exports = {
  siteTitle: "Jean Luc Ponty",
  siteLanguage: "en",
  siteDescription: "Official website for Jean-Luc Ponty, French virtuoso violinist and jazz composer. Find news, concert dates, recordings, videos, fan board, and more.",
  siteUrl: "https://www.ponty.com",
  siteImage: "https://www.ponty.com/cover-og.jpg",
  pathPrefix: "",
  // social
  twitterAccount: "@jlponty",
}